export const EVENT_IMAGE = 'event-image';
export const VENUE_IMAGE = 'image';
